// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file events/v1/order_fulfill.proto (package events.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file events/v1/order_fulfill.proto.
 */
export const file_events_v1_order_fulfill: GenFile =
    /*@__PURE__*/
    fileDesc(
        'Ch1ldmVudHMvdjEvb3JkZXJfZnVsZmlsbC5wcm90bxIJZXZlbnRzLnYxImwKDE9yZGVyRnVsZmlsbBIQCghvcmRlcl9pZBgBIAEoBBIQCghwcm92aWRlchgCIAEoCRISCgVlcnJvchgDIAEoCUgAiAEBEhoKEmZ1bGZpbGxtZW50X3N0YXR1cxgEIAEoCUIICgZfZXJyb3JCbQoNY29tLmV2ZW50cy52MUIRT3JkZXJGdWxmaWxsUHJvdG9QAVoELi9wYqICA0VYWKoCCUV2ZW50cy5WMcoCCUV2ZW50c1xWMeICFUV2ZW50c1xWMVxHUEJNZXRhZGF0YeoCCkV2ZW50czo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message events.v1.OrderFulfill
 */
export type OrderFulfill = Message<'events.v1.OrderFulfill'> & {
    /**
     * @generated from field: uint64 order_id = 1;
     */
    orderId: bigint;

    /**
     * @generated from field: string provider = 2;
     */
    provider: string;

    /**
     * @generated from field: optional string error = 3;
     */
    error?: string | undefined;

    /**
     * @generated from field: string fulfillment_status = 4;
     */
    fulfillmentStatus: string;
};

/**
 * Describes the message events.v1.OrderFulfill.
 * Use `create(OrderFulfillSchema)` to create a new message.
 */
export const OrderFulfillSchema: GenMessage<OrderFulfill> = /*@__PURE__*/ messageDesc(file_events_v1_order_fulfill, 0);
